<template>
  <div>
    <!-- Sección Venta -->
    <v-card class="pa-3 mb-4 transparent">
      <h4 class="font-weight-medium mb-2">Parámetros de Venta</h4>
      <v-divider class="mb-3"></v-divider>

      <v-subheader class="pl-0">Rubro de Venta</v-subheader>
      <RubroVentaListSelect
        :value="rubroVenta"
        @process-select="$emit('update:rubroVenta', $event)"
        title="Seleccionar Rubro Venta"
      />

      <v-subheader class="pl-0 mt-3">IVA Venta</v-subheader>
      <div class="text--secondary text-caption mb-1">Impuesto sobre el valor añadido</div>
      <AlicuotaIvaSelect
        :iva="rubroVenta && rubroVenta.iva ? rubroVenta.iva : {}"
        :isEdit="false"
      />
    </v-card>

    <!-- Sección Compra -->
    <v-card class="pa-3 transparent">
      <h4 class="font-weight-medium mb-2">Parámetros de Compra</h4>
      <v-divider class="mb-3"></v-divider>

      <v-subheader class="pl-0">Rubro de Compra</v-subheader>
      <RubroCompraListSelect
        :value="rubroCompra"
        @process-select="$emit('update:rubroCompra', $event)"
        title="Seleccionar Rubro Compra"
      />

      <v-subheader class="pl-0 mt-3">IVA Compra</v-subheader>
      <div class="text--secondary text-caption mb-1">Impuesto sobre el valor añadido</div>
      <AlicuotaIvaSelect
        :iva="rubroCompra && rubroCompra.iva ? rubroCompra.iva : {}"
        :isEdit="false"
      />
    </v-card>
  </div>
</template>

<script>
import AlicuotaIvaSelect from "@/components/util/AlicuotaIvaSelect.vue";
import RubroVentaListSelect from "@/components/contabilidad/RubroVentaListSelect.vue";
import RubroCompraListSelect from "@/components/contabilidad/RubroCompraListSelect.vue";

export default {
  name: "ProductoSucursalContableUpdate",
  components: {
    AlicuotaIvaSelect,
    RubroVentaListSelect,
    RubroCompraListSelect,
  },
  props: {
    rubroVenta: {
      type: Object,
      default: () => ({}),
    },
    rubroCompra: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
